import type { ShippedClip } from '@/types';

/**
 * Clips served from this site, keyed by the url their gallery item points at.
 *
 * Each source list runs best-first: a browser plays the first one it
 * understands, so VP9 reaches everything current and the H.264 file is there
 * for what cannot. Both are encoded to fit under the 25 MiB Cloudflare Pages
 * accepts per file.
 */
export const SHIPPED_CLIPS: Readonly<Record<string, ShippedClip>> = {
  '/media/athar-ad.mp4': {
    width: 570,
    height: 850,
    sources: [
      { src: '/media/athar-ad.webm', type: 'video/webm' },
      { src: '/media/athar-ad.mp4', type: 'video/mp4' },
    ],
  },
};
